const extractVueFunctions = function() {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_c('QuickNav')],1),_vm._v(" "),_c('h2',{attrs:{"id":"test-app-ante-suos-corpus-triopeius-dominari-rogat-saepe"}},[_vm._v("Ante suos corpus Triopeius dominari rogat saepe")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_c('SiteMeta')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Materia alvo madefacta, parce divulsere. Utinam lacrimas undae? Vetustas illa,\nnec Stygio diu nisi potens quod: laborant. Facinus oppositoque vincar durataeque\nPhoebus igne pascat et "),_c('a',{attrs:{"href":"#nitar-nunc-loco"}},[_vm._v("rutilis Dardaniam Graiae")]),_vm._v(", metus solo\ninvia "),_c('em',[_vm._v("coercet")]),_vm._v(" mihi arbore tener.")])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"title":"Areas Eligible for R3 Program Grants","showInSitemap":false},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }